const COLUMNS_GROUPS = [
  {
    id: "date",
    label: "DATE",
    widget: "text",
    width: 150
  },
  {
    id: "salesorder",
    label: "SALES ORDER#",
    widget: "text",
    width: 200
  },
  {
    id: "reference",
    label: "REFERENCE#",
    widget: "text",
    width: 180
  },
  {
    id: "customername",
    label: "CUSTOMER NAME",
    widget: "text",
    width: 250
  },
  {
    id: "status",
    label: "STATUS",
    widget: "text",
    width: 150
  },
  {
    id: "amount",
    label: "AMOUNT",
    widget: "number",
    width: 150
  },
  {
    id: "invoiced",
    label: "INVOICED",
    widget: "number",
    width: 150
  },
  {
    id: "payment",
    label: "PAYMENT",
    widget: "number",
    width: 150
  }
];

const ROW_DATA = [
  {
    date: "15/12/2025",
    salesorder: "SO-45021",
    reference: "REF-99210",
    customername: "Arvind Textiles",
    status: "Confirmed",
    amount: 180000,
    invoiced: 150000,
    payment: 120000
  },
  {
    date: "12/12/2025",
    salesorder: "SO-44990",
    reference: "REF-99185",
    customername: "Prime Garments",
    status: "Pending",
    amount: 95000,
    invoiced: 0,
    payment: 0
  },
  {
    date: "10/12/2025",
    salesorder: "SO-44955",
    reference: "REF-99140",
    customername: "Meenakshi Fabrics",
    status: "Partially Confirmed",
    amount: 120000,
    invoiced: 60000,
    payment: 40000
  }];

export {COLUMNS_GROUPS,ROW_DATA};